// import React, { useState, useRef, useEffect, useCallback } from 'react'
// import { useQuery } from '@tanstack/react-query'
// import { Editor, Toolbar } from '@wangeditor/editor-for-react'
// import { i18nChangeLanguage } from '@wangeditor/editor'
// import '@wangeditor/editor/dist/css/style.css'

// i18nChangeLanguage('en')

// const EditNewsPage = ({ article, onBack, onUpdate }) => {
//   const [title, setTitle] = useState(article?.title || '')
//   const [mainImageFile, setMainImageFile] = useState(null)
//   const [categoryId, setCategoryId] = useState(article?.category_id || '')
//   const [editorHtml, setEditorHtml] = useState('')
//   const [errors, setErrors] = useState({})
//   const [editor, setEditor] = useState(null)
//   const [addToTinker, setAddToTinker] = useState(article?.add_to_tinker === 1)
//   const [priority, setPriority] = useState(article?.priority || 'عادي')
//   const [isEditorReady, setIsEditorReady] = useState(false)
//   const [isUpdating, setIsUpdating] = useState(false)
//   const [uploadingImages, setUploadingImages] = useState(0)

//   const apiUrl = process.env.REACT_APP_API_URL;

//   // YouTube URL converter function
//   const convertYouTubeUrls = (html) => {
//     const youtubeRegex = /(?:<p[^>]*>)?\s*(?:<a[^>]*>)?(?:https?:\/\/)?(?:www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)(?:[^\s<]*)?(?:<\/a>)?\s*(?:<\/p>)?/gi;
    
//     return html.replace(youtubeRegex, (match, domain, videoId) => {
//       return `<div style="margin: 20px 0; text-align: center;"><iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
//     });
//   };

//   const { data: categoriesData, isLoading: loadingCategories, error: categoriesError } = useQuery({
//     queryKey: ['categories'],
//     queryFn: async () => {
//       const response = await fetch(`${apiUrl}/api/categories`)
//       const data = await response.json()
      
//       if (response.ok && data.success) {
//         return data.data
//       } else {
//         console.error('Failed to fetch categories:', data.error)
//         throw new Error('Failed to fetch categories')
//       }
//     },
//     staleTime: 5 * 60 * 1000, 
//   })

//   const categories = Array.isArray(categoriesData?.data) ? categoriesData.data : []

//   const { data: fullArticle, isLoading: isLoadingArticle } = useQuery({
//     queryKey: ['article', article?.id],
//     queryFn: async () => {
//       const response = await fetch(`${apiUrl}/api/news/${article.id}`)
//       const data = await response.json()
      
//       if (response.ok && data.success) {
//         return data.data
//       } else {
//         throw new Error('Failed to fetch article details')
//       }
//     },
//     enabled: !!(article?.id && !article?.content),
//     staleTime: 2 * 60 * 1000, 
//   })

//   useEffect(() => {
//     const articleContent = fullArticle?.content || article?.content
    
//     if (articleContent && isEditorReady && editor) {
//       setEditorHtml(articleContent)
//       editor.setHtml(articleContent)
//     } else if (articleContent && !isEditorReady) {
//       setEditorHtml(articleContent)
//     }
//   }, [fullArticle?.content, article?.content, isEditorReady, editor])

//   // Image compression function
//   const compressImage = (file, quality = 0.7, maxWidth = 1200) => {
//     return new Promise((resolve) => {
//       const canvas = document.createElement('canvas')
//       const ctx = canvas.getContext('2d')
//       const img = new Image()
      
//       img.onload = () => {
//         let { width, height } = img
//         if (width > maxWidth) {
//           height = (height * maxWidth) / width
//           width = maxWidth
//         }
        
//         canvas.width = width
//         canvas.height = height
//         ctx.drawImage(img, 0, 0, width, height)
//         canvas.toBlob(resolve, file.type, quality)
//       }
      
//       img.src = URL.createObjectURL(file)
//     })
//   }

//   // Custom upload function with compression and API upload
//   const customUploadImg = useCallback(async (file, insertFn) => {
//     try {
//       setUploadingImages(prev => prev + 1)

//       const compressedFile = await compressImage(file, 0.7, 1200) 
      
//       if (compressedFile.size > 2 * 1024 * 1024) {
//         alert('حجم الصورة كبير جداً حتى بعد الضغط. يرجى استخدام صورة أصغر')
//         return
//       }

//       const formData = new FormData()
//       formData.append('image', compressedFile)

//       const response = await fetch(`${apiUrl}/api/upload-image`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${localStorage.getItem('authToken')}`
//         },
//         body: formData,
//       })

//       const data = await response.json()
      
//       if (response.ok && data.success) {
//         insertFn(data.url, compressedFile.name, data.url)
//       } else {
//         throw new Error(data.error || 'فشل في رفع الصورة')
//       }
      
//     } catch (error) {
//       console.error('Upload error:', error)
//       alert('فشل في رفع الصورة: ' + error.message)
//     } finally {
//       setUploadingImages(prev => prev - 1)
//     }
//   }, [apiUrl])

//   const validateForm = () => {
//     const newErrors = {}

//     if (!title.trim()) newErrors.title = 'عنوان الخبر مطلوب'
//     if (!editorHtml.trim() || editorHtml === '<p><br></p>') newErrors.content = 'محتوى الخبر مطلوب'
//     if (!categoryId) newErrors.category = 'فئة الخبر مطلوبة'
    
//     if (uploadingImages > 0) {
//       newErrors.content = 'يرجى انتظار انتهاء رفع الصور'
//     }
    
//     setErrors(newErrors)
//     return Object.keys(newErrors).length === 0
//   }

//   const handleSubmit = async e => {
//     e.preventDefault()
//     if (!validateForm()) return

//     setIsUpdating(true)

//     const formData = new FormData()
//     formData.append('title', title)
//     // Convert YouTube URLs before sending
//     formData.append('content', convertYouTubeUrls(editorHtml))
//     formData.append('category_id', categoryId)
//     formData.append('priority', priority)
//     formData.append('add_to_tinker', addToTinker ? '1' : '0')
    
//     // Only set published_at if moving TO a non-category-4 and currently unpublished
//     const selectedCategory = categoryId.toString()
//     const currentArticle = fullArticle || article
    
//     // if (selectedCategory !== '4' && !currentArticle?.published_at) {
//     //   // Format datetime for MySQL (YYYY-MM-DD HH:MM:SS)
//     //   const now = new Date()
//     //   const mysqlDatetime = now.getFullYear() + '-' + 
//     //     String(now.getMonth() + 1).padStart(2, '0') + '-' + 
//     //     String(now.getDate()).padStart(2, '0') + ' ' + 
//     //     String(now.getHours()).padStart(2, '0') + ':' + 
//     //     String(now.getMinutes()).padStart(2, '0') + ':' + 
//     //     String(now.getSeconds()).padStart(2, '0')
//     //   formData.append('published_at', mysqlDatetime)
//     // }
    
//     formData.append('_method', 'PATCH') 
//     if (mainImageFile) formData.append('main_image', mainImageFile)

//     try {
//       const response = await fetch(`${apiUrl}/api/news/${article.id}`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${localStorage.getItem('authToken')}`
//         },
//         body: formData,
//       })
//       const data = await response.json()

//       if (response.ok) {
//         // Update local state first to reflect changes immediately
//         setTitle(data.data.title)
//         setEditorHtml(data.data.content)
//         setCategoryId(data.data.category_id)
//         setPriority(data.data.priority)
//         setAddToTinker(data.data.add_to_tinker === 1)
        
//         // Then call parent update
//         onUpdate(data.data)

//       } else {
//         alert(data.error || 'Failed to update news')
//       }
//     } catch (error) {
//       alert('Failed to update news: ' + error.message)
//     } finally {
//       setIsUpdating(false)
//     }
//   }

//   const editorConfig = {
//     placeholder: 'اكتب محتوى الخبر هنا... (يمكنك لصق رابط يوتيوب مباشرة وسيتم تحويله تلقائياً)',
//     MENU_CONF: {
//       uploadImage: {
//         customUpload: customUploadImg
//       }
//     },
//     lang: 'en',
//     customAlert: (s, t) => { alert(s) }
//   }

//   const toolbarConfig = {
//     toolbarKeys: [
//       'headerSelect','blockquote','|','bold','underline','italic','through','|',
//       'color','bgColor','|','fontSize','|','bulletedList','numberedList',
//       { 
//         key: 'group-justify', 
//         title: 'Align',
//         iconSvg: '<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z"></path></svg>',
//         menuKeys: ['justifyLeft','justifyRight','justifyCenter','justifyJustify']
//       },
//       '|','emotion','insertLink',
//       { 
//         key: 'group-image', 
//         title: 'Image',
//         iconSvg: '<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>',
//         menuKeys: ['uploadImage']
//       },
//       '|','insertTable','codeBlock','divider','|','undo','redo'
//     ]
//   }

//   const handleEditorChange = useCallback((editor) => {
//     const newHtml = editor.getHtml()
//     setEditorHtml(newHtml)
//     if (errors.content) setErrors(prev => ({ ...prev, content: '' }))
//   }, [errors.content])

//   const handleCreated = useCallback((editor) => { 
//     setEditor(editor)
//     setIsEditorReady(true)
    
//     const articleContent = fullArticle?.content || article?.content
//     if (articleContent) {
//       editor.setHtml(articleContent)
//       setEditorHtml(articleContent)
//     }

//     // Add paste event listener for real-time YouTube URL conversion
//     const editorDom = editor.getEditableContainer()
//     if (editorDom) {
//       editorDom.addEventListener('paste', (event) => {
//         setTimeout(() => {
//           const clipboardData = event.clipboardData || window.clipboardData;
//           const pastedData = clipboardData.getData('text');
          
//           // Check if pasted content is a YouTube URL
//           const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/;
//           const match = pastedData.match(youtubeRegex);
          
//           if (match) {
//             // Get current HTML and replace YouTube URLs
//             const currentHtml = editor.getHtml();
//             const convertedHtml = convertYouTubeUrls(currentHtml);
            
//             // Only update if conversion happened
//             if (convertedHtml !== currentHtml) {
//               editor.setHtml(convertedHtml);
//             }
//           }
//         }, 100); // Small delay to ensure paste content is in editor
//       })
//     }
//   }, [])

//   useEffect(() => {
//     return () => { 
//       if (editor) { 
//         editor.destroy(); 
//         setEditor(null)
//         setIsEditorReady(false)
//       } 
//     }
//   }, [editor])

//   // Content stats calculation
//   const contentStats = React.useMemo(() => {
//     const textLength = editorHtml.length
//     const imageCount = (editorHtml.match(/<img/g) || []).length
//     const youtubeCount = (editorHtml.match(/youtube\.com\/embed\//g) || []).length
//     const hasLargeContent = textLength > 50000
    
//     return {
//       textLength,
//       imageCount,
//       youtubeCount,
//       hasLargeContent,
//       sizeKB: (textLength / 1024).toFixed(1)
//     }
//   }, [editorHtml])

//   // Get helper info for UI feedback
//   const currentArticle = fullArticle || article
//   const selectedCategoryInfo = categories?.find(cat => cat.id === parseInt(categoryId))
//   const isReviewCategory = categoryId === '4'
//   const isCurrentlyPublished = !!currentArticle?.published_at
//   const willBePublished = categoryId !== '4' && !isCurrentlyPublished

//   return (
//     <div>
//       <div className="dashboard-page-header">
//         <div className="dashboard-page-header-actions">
//           <button onClick={onBack} className="dashboard-back-btn">
//             <svg className="dashboard-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
//               strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//               <path d="M19 12H5" /><path d="M12 19l-7-7 7-7" />
//             </svg>
//             العودة للأخبار
//           </button>
//         </div>
//       </div>

//       <form onSubmit={handleSubmit} className="dashboard-add-news-form" encType="multipart/form-data">
//         <div className="dashboard-card">
//           <div className="dashboard-card-header"><h3>تعديل الخبر</h3></div>
//           <div className="dashboard-card-body">
            
//             {/* Current publish status */}
//             <div style={{ 
//               marginBottom: '16px', 
//               padding: '12px', 
//               backgroundColor: isCurrentlyPublished ? '#d4edda' : '#f8d7da', 
//               border: `1px solid ${isCurrentlyPublished ? '#c3e6cb' : '#f5c6cb'}`, 
//               borderRadius: '4px',
//               fontSize: '0.9em',
//               textAlign: 'right'
//             }}>
//               {isCurrentlyPublished ? 
//                 `✅ الخبر منشور حالياً (${currentArticle.published_at ? new Date(currentArticle.published_at).toLocaleDateString('ar-EG') : 'تاريخ غير متاح'})` : 
//                 '⏳ الخبر غير منشور (في المراجعة)'}
//             </div>

//             <div className="dashboard-form-group">
//               <label htmlFor="title" className="dashboard-form-label">عنوان الخبر *</label>
//               <input id="title" name="title" value={title}
//                 onChange={e => { setTitle(e.target.value); if (errors.title) setErrors(prev => ({ ...prev, title: '' })) }}
//                 className={`dashboard-form-input ${errors.title ? 'dashboard-error' : ''}`}
//                 placeholder="اكتب عنوان الخبر هنا..."
//                 style={{ textAlign: 'right', color: '#000000', backgroundColor: '#ffffff' }} />
//               {errors.title && <span className="dashboard-error-message">{errors.title}</span>}
//             </div>

//             {/* <div className="dashboard-form-group">
//               <label htmlFor="mainImage" className="dashboard-form-label">الصورة الرئيسية</label>
//               <input id="mainImage" name="mainImage" type="file" accept="image/*"
//                 onChange={e => setMainImageFile(e.target.files[0])}
//                 className="dashboard-form-input" style={{ textAlign: 'right' }} />
//               {article?.main_image && !mainImageFile && (
//                 <div style={{ marginTop: '8px', textAlign: 'right' }}>
//                   <small>الصورة الحالية: {article.main_image}</small>
//                 </div>
//               )}
//             </div> */}

//             <div className="dashboard-form-group">
//               <label htmlFor="category" className="dashboard-form-label">فئة الخبر *</label>
//               <select id="category" name="category" value={categoryId}
//                 onChange={e => { setCategoryId(e.target.value); if (errors.category) setErrors(prev => ({ ...prev, category: '' })) }}
//                 className={`dashboard-form-input ${errors.category ? 'dashboard-error' : ''}`}
//                 style={{ textAlign: 'right' }} disabled={loadingCategories}>
//                 <option value="">{loadingCategories ? 'جاري تحميل الفئات...' : 'اختر الفئة...'}</option>
//                 {categories && categories.length > 0 ? (
//                   categories.map(category => (
//                     <option key={category.id} value={category.id}>{category.display_name}</option>
//                   ))
//                 ) : (
//                   !loadingCategories && <option value="">لا توجد فئات متاحة</option>
//                 )}
//               </select>
//               {errors.category && <span className="dashboard-error-message">{errors.category}</span>}
              
//               {/* Show what will happen based on category change */}
//               {willBePublished && (
//                 <div style={{ 
//                   marginTop: '8px', 
//                   padding: '8px 12px', 
//                   backgroundColor: '#d1ecf1', 
//                   border: '1px solid #74c0fc', 
//                   borderRadius: '4px',
//                   fontSize: '0.9em',
//                   textAlign: 'right'
//                 }}>
//                   🚀 سيتم نشر الخبر تلقائياً عند الحفظ (لأن الخبر لم يكن منشوراً من قبل)
//                 </div>
//               )}
//               {isReviewCategory && isCurrentlyPublished && (
//                 <div style={{ 
//                   marginTop: '8px', 
//                   padding: '8px 12px', 
//                   backgroundColor: '#fff3cd', 
//                   border: '1px solid #ffeaa7', 
//                   borderRadius: '4px',
//                   fontSize: '0.9em',
//                   textAlign: 'right'
//                 }}>
//                   ⚠️ نقل الخبر إلى المراجعة سيبقي تاريخ النشر الحالي
//                 </div>
//               )}
//               {isReviewCategory && !isCurrentlyPublished && (
//                 <div style={{ 
//                   marginTop: '8px', 
//                   padding: '8px 12px', 
//                   backgroundColor: '#fff3cd', 
//                   border: '1px solid #ffeaa7', 
//                   borderRadius: '4px',
//                   fontSize: '0.9em',
//                   textAlign: 'right'
//                 }}>
//                   📝 الخبر سيبقى في المراجعة ولن يتم نشره
//                 </div>
//               )}
//             </div>

//             <div className="dashboard-form-group">
//               <label className="dashboard-form-label">أولوية الخبر</label>
//               <select value={priority} onChange={e => setPriority(e.target.value)}
//                 className="dashboard-form-input" style={{ textAlign: 'right' }}>
//                 <option value="عاجل">عاجل</option>
//                 <option value="عادي">عادي</option>
//               </select>
//             </div>

//             <div className="dashboard-form-group">
//               <label className="dashboard-form-label" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
//                 <input type="checkbox" checked={addToTinker} onChange={e => setAddToTinker(e.target.checked)}
//                   style={{ marginLeft: '8px' }} />
//                 إضافة إلى شريط الأخبار
//               </label>
//             </div>

//             <div className="dashboard-form-group" style={{ direction: 'rtl' }}>
//               <label className="dashboard-form-label">محتوى الخبر *
//                 <span style={{ fontSize: '0.9em', color: '#666', fontWeight: 'normal' }}>
//                   (يمكنك لصق رابط يوتيوب مباشرة)
//                 </span>
//               </label>

//               {/* Show upload status */}
//               {uploadingImages > 0 && (
//                 <div style={{ 
//                   padding: '8px 12px', 
//                   backgroundColor: '#e3f2fd', 
//                   border: '1px solid #2196f3', 
//                   borderRadius: '4px', 
//                   marginBottom: '8px',
//                   textAlign: 'center'
//                 }}>
//                   جاري رفع {uploadingImages} صورة... يرجى الانتظار
//                 </div>
//               )}

//               {isLoadingArticle && (
//                 <div style={{ padding: '10px', textAlign: 'center', color: '#666' }}>
//                   جاري تحميل المحتوى...
//                 </div>
//               )}
              
//               <div style={{ border: '1px solid #ccc', zIndex: 100 }}>
//                 <Toolbar editor={editor} defaultConfig={toolbarConfig} mode="default"
//                   style={{ borderBottom: '1px solid #ccc' }} />
//                 <Editor 
//                   defaultConfig={editorConfig} 
//                   value={editorHtml}
//                   onCreated={handleCreated} 
//                   onChange={handleEditorChange}
//                   mode="default" 
//                   style={{ 
//                     minHeight: '300px', 
//                     opacity: isLoadingArticle ? 0.5 : 1 
//                   }} />
//               </div>
//               {errors.content && <span className="dashboard-error-message">{errors.content}</span>}
//             </div>

//             {/* Content stats */}
//             <div style={{ 
//               marginTop: '8px', 
//               textAlign: 'right', 
//               color: contentStats.hasLargeContent ? '#f44336' : '#555',
//               fontSize: '0.9em'
//             }}>
//               حجم النص: {contentStats.sizeKB} KB | الصور: {contentStats.imageCount} | فيديوهات يوتيوب: {contentStats.youtubeCount}
//               {contentStats.hasLargeContent && (
//                 <span style={{ display: 'block', color: '#f44336' }}>
//                   ⚠️ المحتوى كبير جداً - قد يؤثر على الأداء
//                 </span>
//               )}
//             </div>

//             <div className="dashboard-form-actions">
//               <button 
//                 type="submit" 
//                 className="dashboard-btn dashboard-btn-primary"
//                 disabled={isUpdating || uploadingImages > 0}
//               >
//                 {isUpdating ? 'جاري تحديث الخبر...' : 
//                  uploadingImages > 0 ? `رفع الصور (${uploadingImages})...` : 
//                  'حفظ التعديلات'}
//               </button>
//             </div>
//           </div>
//         </div>
//       </form>
//     </div>
//   )
// }

// export default EditNewsPage

import React, { useState, useRef, useEffect, useCallback } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Editor, Toolbar } from '@wangeditor/editor-for-react'
import { i18nChangeLanguage } from '@wangeditor/editor'
import '@wangeditor/editor/dist/css/style.css'

i18nChangeLanguage('en')

const EditNewsPage = ({ article, onBack, onUpdate, onRefresh }) => {
  const [title, setTitle] = useState(article?.title || '')
  const [mainImageFile, setMainImageFile] = useState(null)
  const [categoryId, setCategoryId] = useState(article?.category_id || '')
  const [editorHtml, setEditorHtml] = useState('')
  const [errors, setErrors] = useState({})
  const [editor, setEditor] = useState(null)
  const [addToTinker, setAddToTinker] = useState(article?.add_to_tinker === 1)
  const [priority, setPriority] = useState(article?.priority || 'عادي')
  const [isEditorReady, setIsEditorReady] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)
  const [uploadingImages, setUploadingImages] = useState(0)

  const apiUrl = process.env.REACT_APP_API_URL;

  // ADD THIS: Effect to sync state when article prop changes
  useEffect(() => {
    if (article) {
      setTitle(article.title || '')
      setCategoryId(String(article.category_id) || '')
      setAddToTinker(article.add_to_tinker === 1)
      setPriority(article.priority || 'عادي')
    }
  }, [article?.id, article?.title, article?.category_id, article?.add_to_tinker, article?.priority])

  // YouTube URL converter function
  const convertYouTubeUrls = (html) => {
    const youtubeRegex = /(?:<p[^>]*>)?\s*(?:<a[^>]*>)?(?:https?:\/\/)?(?:www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)(?:[^\s<]*)?(?:<\/a>)?\s*(?:<\/p>)?/gi;
    
    return html.replace(youtubeRegex, (match, domain, videoId) => {
      return `<div style="margin: 20px 0; text-align: center;"><iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
    });
  };

  const { data: categoriesData, isLoading: loadingCategories, error: categoriesError } = useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      try {
        const response = await fetch(`${apiUrl}/api/categories`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
            'Content-Type': 'application/json'
          }
        })
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        
        const data = await response.json()

        
        if (data.success) {
          return data.data || data
        } else {
          console.error('Categories API Error:', data.error)
          throw new Error(data.error || 'Failed to fetch categories')
        }
      } catch (error) {
        console.error('Categories fetch error:', error)
        throw error
      }
    },
    staleTime: 5 * 60 * 1000,
    retry: 3,
    retryDelay: 1000
  })

  const categories = Array.isArray(categoriesData?.data) ? categoriesData.data : 
                    Array.isArray(categoriesData) ? categoriesData : []

  const { data: fullArticle, isLoading: isLoadingArticle } = useQuery({
    queryKey: ['article', article?.id],
    queryFn: async () => {
      const response = await fetch(`${apiUrl}/api/news/${article.id}`)
      const data = await response.json()
      
      if (response.ok && data.success) {
        return data.data
      } else {
        throw new Error('Failed to fetch article details')
      }
    },
    enabled: !!(article?.id && !article?.content),
    staleTime: 2 * 60 * 1000, 
  })

  // MODIFIED: Better handling of content updates
  useEffect(() => {
    const articleContent = fullArticle?.content || article?.content
    
    if (articleContent && isEditorReady && editor) {
      setEditorHtml(articleContent)
      editor.setHtml(articleContent)
    } else if (articleContent && !isEditorReady) {
      setEditorHtml(articleContent)
    }
  }, [fullArticle?.content, article?.content, isEditorReady, editor])

  // MODIFIED: Sync state when fullArticle is loaded
  useEffect(() => {
    if (fullArticle) {
      setTitle(fullArticle.title || '')
      setCategoryId(String(fullArticle.category_id) || '')
      setAddToTinker(fullArticle.add_to_tinker === 1)
      setPriority(fullArticle.priority || 'عادي')
    }
  }, [fullArticle])

  // Image compression function
  const compressImage = (file, quality = 0.7, maxWidth = 1200) => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const img = new Image()
      
      img.onload = () => {
        let { width, height } = img
        if (width > maxWidth) {
          height = (height * maxWidth) / width
          width = maxWidth
        }
        
        canvas.width = width
        canvas.height = height
        ctx.drawImage(img, 0, 0, width, height)
        canvas.toBlob(resolve, file.type, quality)
      }
      
      img.src = URL.createObjectURL(file)
    })
  }

  // Custom upload function with compression and API upload
  const customUploadImg = useCallback(async (file, insertFn) => {
    try {
      setUploadingImages(prev => prev + 1)

      const compressedFile = await compressImage(file, 0.7, 1200) 
      
      if (compressedFile.size > 2 * 1024 * 1024) {
        alert('حجم الصورة كبير جداً حتى بعد الضغط. يرجى استخدام صورة أصغر')
        return
      }

      const formData = new FormData()
      formData.append('image', compressedFile)

      const response = await fetch(`${apiUrl}/api/upload-image`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: formData,
      })

      const data = await response.json()
      
      if (response.ok && data.success) {
        insertFn(data.url, compressedFile.name, data.url)
      } else {
        throw new Error(data.error || 'فشل في رفع الصورة')
      }
      
    } catch (error) {
      console.error('Upload error:', error)
      alert('فشل في رفع الصورة: ' + error.message)
    } finally {
      setUploadingImages(prev => prev - 1)
    }
  }, [apiUrl])

  const validateForm = () => {
    const newErrors = {}

    if (!title.trim()) newErrors.title = 'عنوان الخبر مطلوب'
    if (!editorHtml.trim() || editorHtml === '<p><br></p>') newErrors.content = 'محتوى الخبر مطلوب'
    if (!categoryId) newErrors.category = 'فئة الخبر مطلوبة'
    
    if (uploadingImages > 0) {
      newErrors.content = 'يرجى انتظار انتهاء رفع الصور'
    }
    
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async e => {
    e.preventDefault()
    
    if (isUpdating) {
      return
    }
    
    if (!validateForm()) return

    setIsUpdating(true)

    const formData = new FormData()
    formData.append('title', title)
    // Convert YouTube URLs before sending
    formData.append('content', convertYouTubeUrls(editorHtml))
    formData.append('category_id', categoryId)
    formData.append('priority', priority)
    formData.append('add_to_tinker', addToTinker ? '1' : '0')
    
    formData.append('_method', 'PATCH') 
    if (mainImageFile) formData.append('main_image', mainImageFile)

    try {

      const response = await fetch(`${apiUrl}/api/news/${article.id}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: formData,
      })
      const data = await response.json()

      if (response.ok) {
        // Check if category changed and show message
        const originalCategoryId = article.category_id;
        const newCategoryId = data.data.category_id;
        
        if (originalCategoryId !== newCategoryId) {
          const categoryNames = {
            1: 'وسط',
            2: 'مقالات', 
            3: 'أخبار رياضية',
            4: 'مراجعة'
          };
        } else {
          alert('تم تحديث المقال بنجاح');
        }
        
        // MODIFIED: Update local state with the response data
        const updatedArticle = data.data
        setTitle(updatedArticle.title)
        setEditorHtml(updatedArticle.content)
        setCategoryId(updatedArticle.category_id.toString()) // IMPORTANT: Ensure string type
        setPriority(updatedArticle.priority)
        setAddToTinker(updatedArticle.add_to_tinker === 1)
        
        // Call parent update
        onUpdate(updatedArticle)
        
        // Call refresh callback to update the articles table
        if (onRefresh) {
          onRefresh()
        }

      } else {
        console.error('EditNewsPage: Update failed:', data.error)
        alert(data.error || 'Failed to update news')
      }
    } catch (error) {
      console.error('EditNewsPage: Update error:', error)
      alert('Failed to update news: ' + error.message)
    } finally {
      setIsUpdating(false)
    }
  }

  const editorConfig = {
    placeholder: 'اكتب محتوى الخبر هنا... (يمكنك لصق رابط يوتيوب مباشرة وسيتم تحويله تلقائياً)',
    MENU_CONF: {
      uploadImage: {
        customUpload: customUploadImg
      }
    },
    lang: 'en',
    customAlert: (s, t) => { alert(s) }
  }

  const toolbarConfig = {
    toolbarKeys: [
      'headerSelect','blockquote','|','bold','underline','italic','through','|',
      'color','bgColor','|','fontSize','|','bulletedList','numberedList',
      { 
        key: 'group-justify', 
        title: 'Align',
        iconSvg: '<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z"></path></svg>',
        menuKeys: ['justifyLeft','justifyRight','justifyCenter','justifyJustify']
      },
      '|','emotion','insertLink',
      { 
        key: 'group-image', 
        title: 'Image',
        iconSvg: '<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>',
        menuKeys: ['uploadImage']
      },
      '|','insertTable','codeBlock','divider','|','undo','redo'
    ]
  }

  const handleEditorChange = useCallback((editor) => {
    const newHtml = editor.getHtml()
    setEditorHtml(newHtml)
    if (errors.content) setErrors(prev => ({ ...prev, content: '' }))
  }, [errors.content])

  const handleCreated = useCallback((editor) => { 
    setEditor(editor)
    setIsEditorReady(true)
    
    const articleContent = fullArticle?.content || article?.content
    if (articleContent) {
      editor.setHtml(articleContent)
      setEditorHtml(articleContent)
    }

    // Add paste event listener for real-time YouTube URL conversion
    const editorDom = editor.getEditableContainer()
    if (editorDom) {
      editorDom.addEventListener('paste', (event) => {
        setTimeout(() => {
          const clipboardData = event.clipboardData || window.clipboardData;
          const pastedData = clipboardData.getData('text');
          
          // Check if pasted content is a YouTube URL
          const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/;
          const match = pastedData.match(youtubeRegex);
          
          if (match) {
            // Get current HTML and replace YouTube URLs
            const currentHtml = editor.getHtml();
            const convertedHtml = convertYouTubeUrls(currentHtml);
            
            // Only update if conversion happened
            if (convertedHtml !== currentHtml) {
              editor.setHtml(convertedHtml);
            }
          }
        }, 100); // Small delay to ensure paste content is in editor
      })
    }
  }, [fullArticle?.content, article?.content])

  useEffect(() => {
    return () => { 
      if (editor) { 
        editor.destroy(); 
        setEditor(null)
        setIsEditorReady(false)
      } 
    }
  }, [editor])

  // Content stats calculation
  const contentStats = React.useMemo(() => {
    const textLength = editorHtml.length
    const imageCount = (editorHtml.match(/<img/g) || []).length
    const youtubeCount = (editorHtml.match(/youtube\.com\/embed\//g) || []).length
    const hasLargeContent = textLength > 50000
    
    return {
      textLength,
      imageCount,
      youtubeCount,
      hasLargeContent,
      sizeKB: (textLength / 1024).toFixed(1)
    }
  }, [editorHtml])

  // Get helper info for UI feedback
  const currentArticle = fullArticle || article
  const selectedCategoryInfo = categories?.find(cat => cat.id === parseInt(categoryId))
  const isReviewCategory = categoryId === '4'
  const isCurrentlyPublished = !!currentArticle?.published_at
  const willBePublished = categoryId !== '4' && !isCurrentlyPublished

  

  return (
    <div>
      <div className="dashboard-page-header">
        <div className="dashboard-page-header-actions">
          <button onClick={onBack} className="dashboard-back-btn">
            <svg className="dashboard-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5" /><path d="M12 19l-7-7 7-7" />
            </svg>
            العودة للأخبار
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="dashboard-add-news-form" encType="multipart/form-data">
        <div className="dashboard-card">
          <div className="dashboard-card-header"><h3>تعديل الخبر</h3></div>
          <div className="dashboard-card-body">

            <div className="dashboard-form-group">
              <label htmlFor="title" className="dashboard-form-label">عنوان الخبر *</label>
              <input id="title" name="title" value={title}
                onChange={e => { setTitle(e.target.value); if (errors.title) setErrors(prev => ({ ...prev, title: '' })) }}
                className={`dashboard-form-input ${errors.title ? 'dashboard-error' : ''}`}
                placeholder="اكتب عنوان الخبر هنا..."
                style={{ textAlign: 'right', color: '#000000', backgroundColor: '#ffffff' }} />
              {errors.title && <span className="dashboard-error-message">{errors.title}</span>}
            </div>

            <div className="dashboard-form-group">
              <label htmlFor="category" className="dashboard-form-label">فئة الخبر *</label>
              <select 
                id="category" 
                name="category" 
                value={categoryId}
                onChange={e => { 
                  
                  setCategoryId(e.target.value); 
                  if (errors.category) setErrors(prev => ({ ...prev, category: '' })) 
                }}
                className={`dashboard-form-input ${errors.category ? 'dashboard-error' : ''}`}
                style={{ textAlign: 'right' }} 
                disabled={loadingCategories}>
                <option value="">{loadingCategories ? 'جاري تحميل الفئات...' : 'اختر الفئة...'}</option>
                {categories && categories.length > 0 ? (
                  categories.map(category => (
                    <option key={category.id} value={category.id}>
                      {category.display_name}
                    </option>
                  ))
                ) : (
                  !loadingCategories && <option value="">لا توجد فئات متاحة</option>
                )}
              </select>
              {errors.category && <span className="dashboard-error-message">{errors.category}</span>}
              
              {isReviewCategory && isCurrentlyPublished && (
                <div style={{ 
                  marginTop: '8px', 
                  padding: '8px 12px', 
                  backgroundColor: '#fff3cd', 
                  border: '1px solid #ffeaa7', 
                  borderRadius: '4px',
                  fontSize: '0.9em',
                  textAlign: 'right'
                }}>
                  ⚠️ نقل الخبر إلى المراجعة سيبقي تاريخ النشر الحالي
                </div>
              )}
              {isReviewCategory && !isCurrentlyPublished && (
                <div style={{ 
                  marginTop: '8px', 
                  padding: '8px 12px', 
                  backgroundColor: '#fff3cd', 
                  border: '1px solid #ffeaa7', 
                  borderRadius: '4px',
                  fontSize: '0.9em',
                  textAlign: 'right'
                }}>
                  📝 الخبر سيبقى في المراجعة ولن يتم نشره
                </div>
              )}
            </div>

            <div className="dashboard-form-group">
              <label className="dashboard-form-label">أولوية الخبر</label>
              <select value={priority} onChange={e => setPriority(e.target.value)}
                className="dashboard-form-input" style={{ textAlign: 'right' }}>
                <option value="عاجل">عاجل</option>
                <option value="عادي">عادي</option>
              </select>
            </div>

            <div className="dashboard-form-group">
              <label className="dashboard-form-label" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                <input type="checkbox" checked={addToTinker} onChange={e => setAddToTinker(e.target.checked)}
                  style={{ marginLeft: '8px' }} />
                إضافة إلى شريط الأخبار
              </label>
            </div>

            <div className="dashboard-form-group" style={{ direction: 'rtl' }}>
              <label className="dashboard-form-label">محتوى الخبر *
                <span style={{ fontSize: '0.9em', color: '#666', fontWeight: 'normal' }}>
                  (يمكنك لصق رابط يوتيوب مباشرة)
                </span>
              </label>

              {/* Show upload status */}
              {uploadingImages > 0 && (
                <div style={{ 
                  padding: '8px 12px', 
                  backgroundColor: '#e3f2fd', 
                  border: '1px solid #2196f3', 
                  borderRadius: '4px', 
                  marginBottom: '8px',
                  textAlign: 'center'
                }}>
                  جاري رفع {uploadingImages} صورة... يرجى الانتظار
                </div>
              )}

              {isLoadingArticle && (
                <div style={{ padding: '10px', textAlign: 'center', color: '#666' }}>
                  جاري تحميل المحتوى...
                </div>
              )}
              
              <div style={{ border: '1px solid #ccc', zIndex: 100 }}>
                <Toolbar editor={editor} defaultConfig={toolbarConfig} mode="default"
                  style={{ borderBottom: '1px solid #ccc' }} />
                <Editor 
                  defaultConfig={editorConfig} 
                  value={editorHtml}
                  onCreated={handleCreated} 
                  onChange={handleEditorChange}
                  mode="default" 
                  style={{ 
                    minHeight: '300px', 
                    opacity: isLoadingArticle ? 0.5 : 1 
                  }} />
              </div>
              {errors.content && <span className="dashboard-error-message">{errors.content}</span>}
            </div>

            {/* Content stats */}
            <div style={{ 
              marginTop: '8px', 
              textAlign: 'right', 
              color: contentStats.hasLargeContent ? '#f44336' : '#555',
              fontSize: '0.9em'
            }}>
              حجم النص: {contentStats.sizeKB} KB | الصور: {contentStats.imageCount} | فيديوهات يوتيوب: {contentStats.youtubeCount}
              {contentStats.hasLargeContent && (
                <span style={{ display: 'block', color: '#f44336' }}>
                  ⚠️ المحتوى كبير جداً - قد يؤثر على الأداء
                </span>
              )}
            </div>

            <div className="dashboard-form-actions">
              <button 
                type="submit" 
                className="dashboard-btn dashboard-btn-primary"
                disabled={isUpdating || uploadingImages > 0}
                style={{ 
                  opacity: (isUpdating || uploadingImages > 0) ? 0.6 : 1,
                  cursor: (isUpdating || uploadingImages > 0) ? 'not-allowed' : 'pointer'
                }}
              >
                {isUpdating ? 'جاري تحديث الخبر...' : 
                 uploadingImages > 0 ? `رفع الصور (${uploadingImages})...` : 
                 'حفظ التعديلات'}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default EditNewsPage